<div class="_form-full-address-component">
    
	<div class="_data-container">
		<div class="_data _full" *ngIf="formGroup.enabled">
			<form-search-address label="{{ 'ADDRESS.SEARCH_ADDRESS' | translate }}" (selected)="onAddressSelected($any($event))"></form-search-address>
		</div>
		
		<div class="_data _full">
            <form-input label="{{ 'ADDRESS.STREET' | translate }}" [formControl]="formGroup.get('street') | cast"></form-input>
		</div>
		
		<div class="_data">
            <form-input label="{{ 'ADDRESS.HOUSENUMBER' | translate }}" [formControl]="formGroup.get('number') | cast"></form-input>
		</div>
		
		<div class="_data">
            <form-input label="{{ 'ADDRESS.FLOOR' | translate }}" [formControl]="formGroup.get('postbox') | cast"></form-input>
		</div>
		
		<div class="_data">
            <form-input [readonly]="blockZipcode" label="{{ 'ADDRESS.ZIPCODE' | translate }}" [formControl]="formGroup.get('zipcode') | cast"></form-input>
		</div>
		
		<div class="_data _full">
            <form-input [readonly]="blockZipcode" label="{{ 'ADDRESS.CITY' | translate }}" [formControl]="formGroup.get('city') | cast"></form-input>
        </div>

	</div>
	
</div>